<template>
  <div class="product-item cursor-pointer flex flex-row space-x-4 lg:space-x-8" @click="routeToUrl">
    <div class="flex-initial w-1/2 lg:w-1/3 lg:min-w-max">
      <img :src="img" :alt="title" class="product__image" />
    </div>
    <div class="product-item__body flex-1 w-1/2 lg:w-auto">
      <h3 class="product-item__title">
        {{ title }}
      </h3>
      <div class="product-item__description">{{ description }}</div>
      <div class="product-item__category">{{ category }}</div>
      <div class="lg:flex lg:justify-between">
        <div class="product-item__price">
          <span>
            {{
              $t('common.includeTax', {
                num: price,
              })
            }}
          </span>
          <br />
          <span v-if="listedPrice" class="text-xs leading-3 font-bold">
            {{
              $t('common.listedPrice', {
                num: listedPrice,
              })
            }}
          </span>
        </div>
        <el-tag
          v-if="[Constants.SALE_TYPE.SUBSCRIPTION, Constants.SALE_TYPE.BOTH].includes(saleType)"
          class="mt-2 lg:mt-6 text-sm leading-normal h-6"
          >{{ getTagText }}</el-tag
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getDevice, DEVICE } from '@/utils/helper.js'

export default {
  props: {
    img: {
      type: String,
      required: false,
      default: () => '',
    },

    title: {
      type: String,
      required: false,
      default: () => '',
    },

    description: {
      type: String,
      required: false,
      default: () => '',
    },

    category: {
      type: String,
      required: false,
      default: () => '',
    },

    price: {
      type: String,
      required: false,
      default: '',
    },

    listedPrice: {
      type: String,
      required: false,
      default: '',
    },

    id: {
      type: [Number, String],
      required: false,
      default: () => '',
    },

    url: {
      type: [String, Object],
      required: false,
      default: () => '',
    },

    saleType: {
      type: [Number, String],
      required: true,
      default: () => 1,
    },
  },
  computed: {
    getTagText() {
      return getDevice() === DEVICE.SP
        ? this.$t('ec-line001.content.tagTextSP')
        : this.$t('ec-line001.content.tagTextPC')
    },
  },
  methods: {
    routeToUrl() {
      this.$router.push(this.url)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/product-item.scss';
</style>
